import React from 'react';
import CustomTable from '../../components/CustomTable';
import {globales, funciones } from '../../global';
import AuthService            from '../../AuthService';
import Request from 'superagent';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import {Table, TableSelection, TableFixedColumns} from '@devexpress/dx-react-grid-material-ui';
import Checkbox from '@material-ui/core/Checkbox';
import {IntegratedFiltering} from '@devexpress/dx-react-grid';

let Auth = new AuthService();
let tokenInfo = [];

var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
let checkId = undefined;

const styles = theme => ({

backdrop: {
  zIndex: 500000,
  color: '#fff', 
  flexDirection: 'column'
},
paperTitle: { 
 height: '40px', 
 textAlign: 'center',
 verticalAlign: 'middle',
 lineHeight: '40px',
 margin: "1px " + globales.tabla.marginright + "px 0px " + globales.tabla.marginleft + "px", 
 marginBottom: '10px'
},
});
const widthTable = !movil ? window.screen.width - (globales.tabla.marginleft + globales.tabla.marginright) : 1336;
const columns =  [  
  {name: 'ID_SECCION_CLIENTE', title: 'ID_SECCION_CLIENTE'},
  {name: 'CODIGO_CURSO', title: 'Código'},
  {name: 'DESCRIPCION_CURSO', title: 'Descripción'},
  {name: 'MODALIDAD', title: 'Modalidad'},
  {name: 'CREDITOS', title: 'Créditos'},
  {name: 'MONTO', title: 'Monto'},
  {name: 'DESCRIPCION_NIVEL', title: 'DESCRIPCION_NIVEL'},
];
const columnExtensions = [
  { columnName: 'CODIGO_CURSO', width: widthTable * 0.12 },
  { columnName: 'DESCRIPCION_CURSO', width: widthTable * 0.33 }, 
  { columnName: 'MODALIDAD', width: widthTable * 0.13, align: 'center'},
  { columnName: 'CREDITOS', width: widthTable * 0.09, align: 'center'},   
  { columnName: 'MONTO', width: widthTable * 0.10, align: 'center'},  
  { columnName: 'DESCRIPCION_NIVEL', width: 0},          
];

const settingFilter = [
  { columnName: 'MONTO',
     predicate: (value, filter, row) => {
                value = funciones.formatCurrency(value); 
                return IntegratedFiltering.defaultPredicate(value, filter, row);
               },

  },
];

const GroupCellContent = ({ column, row }) => { 
  return(<strong>{row.value}</strong>);
}
const TableSelectionCellComponent = (estado, checkId) => ({style, ...props}) =>{
    
  if (estado && props.row.ID_SECCION_CLIENTE === checkId)
  {
   return (<Table.Cell style={{ ...style, paddingBottom: 0, paddingTop: 2, paddingLeft: 20 }} {...props}>
             <CircularProgress size={22} color="secondary"/>
           </Table.Cell>);
  }                          
  
  if (!Boolean(props.row.MODIFICABLE))
  { 
    return (<Table.Cell style={{ ...style, paddingBottom: 0, paddingTop: 0, paddingRight: 0, paddingLeft: 18 }} {...props}>
              <Checkbox disabled checked={Boolean(props.row.CHECKED)} />
            </Table.Cell>);
  }
  
  return (<TableSelection.Cell style={style} {...props}/>);
}
const VirtualTable_cellComponent = (props) => {  
      
  if (props.column.name === 'MONTO')
  {
    return (<Table.Cell {...props}>
             {funciones.formatCurrency(props.row.MONTO)}            
            </ Table.Cell>);
  }
  
      
  return (<Table.Cell {...props}/>);
    
}
const ColumnFixed_cellComponent = ({ showRightDivider, showLeftDivider, ...props}) => { 
  
  if (props.tableRow.key === "Symbol(filter)"){
    return (<TableFixedColumns.Cell {...props}>
              <div style={{ background: "white", height: "30px", width: "100%" }} />
            </TableFixedColumns.Cell>);
  }

  return (<TableFixedColumns.Cell 
            showRightDivider={false}
            showLeftDivider={false}
            style={{ backgroundColor: 'inherit' }}
            {...props} />);
}

export default withStyles(styles) ( 
class App extends React.Component {

tablaRef = React.createRef();

  constructor (props) {
    super(props);
    this.l=props.l
    this.e=props.e
    this.i=props.i
    this.state = {
       isLoggin : undefined,
       heightTableMain: 0,
       loadingMain: true,
       rows: [],
       openBackDrop: false,
       expandedGroups: [],
       selection: [],
       loadingCheck: false,
   };
}

obtener_cursos = ()=>{

new Request
  .get(`${globales.ip}/extraordinario/cursos/${tokenInfo.user}`)
  .set({'authorization': 'Bearer ' + Auth.getToken() })
  .retry(1)
  .timeout({ response: 15000, deadline: 30000, }) 
  .end((err, res) => {
          
     if (err) { 
  
       if (err.toString().substr(0,16) === 'Error: Forbidden')
       {
              
        window.location.reload();
        return;
                
       }
  
       this.setState({ loadingMain: false }, ()=>{ 
         funciones.showToast('e', 'No hay conexión'); 
       }); 
                  
       return;
     }
        
     const rows = JSON.parse(res.text);
     let expandedGroups = [];
     let selection = [];
     rows.map((item)=>{
      if (!expandedGroups.find(x => x === item.DESCRIPCION_NIVEL))
       expandedGroups.push(item.DESCRIPCION_NIVEL); 

      if (Boolean(item.CHECKED) && !selection.find(x => x.ID_SECCION_CLIENTE === item.ID_SECCION_CLIENTE))
       selection.push(item.ID_SECCION_CLIENTE);

      return item;
     })

     this.setState({ rows, 
                     selection,
                     expandedGroups, 
                     loadingMain: false });            
     
 });

}

changeExpandedGroups = expandedGroups =>{
  this.setState({ expandedGroups });
}

changeSelection = selection =>{ 
 
 checkId = funciones.getIdRowChecking(selection, this.state.selection); 
 const tipo_proceso = selection.length > this.state.selection.length ? 1 : 2;
 const accion = tipo_proceso === 1 ? "marcado" : "desmarcado";

 this.setState({ loadingCheck: true }, ()=>{
   
  new Request
    .post(`${globales.ip}/extraordinario`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .set('Content-Type', 'application/json')
    .send({ id_seccion_cliente: checkId,
            tipo_proceso, 
            cuenta_alumno: tokenInfo.user, 
            ad_usuario: tokenInfo.user })
    .retry(0)
    .timeout({ response: 15000, deadline: 30000, }) 
    .end((err, res) => {
            
       if (err) { 
    
          if (err.toString().substr(0,16) === 'Error: Forbidden')
          {
                
            window.location.reload();
            return;
                  
          }
                    
          this.setState({ loadingCheck: false }, ()=> { 
            funciones.showToast('e', 'No hay conexión'); 
          });
                
          return;
       }
          
      const rows = JSON.parse(res.text);
 
      this.setState({ loadingCheck: false }, ()=>{
        if (rows[0].RESP === 'OK')
         this.setState({ selection }, ()=>{
          funciones.showToast("s", "Ha " + accion + " el examen extraordinario");
         });
        else
        funciones.showToast("w", rows[0].RESP);
      });       

  });

});

 //console.log(checkId);
 
 //this.setState({ selection });
}

componentDidMount() { //Load
 
 tokenInfo = Auth.getProfile(); //Token decodificado

 this.setState({ isLoggin: tokenInfo.plataforma !== undefined ? true : false }, ()=>{  
 
  if (tokenInfo.plataforma === 2) //Usuario estudiante
  {
    this.obtener_cursos();    
  }
    
  this.setState({ heightTableMain: funciones.getHeightTableMain(movil, this).heightTable }); 

 }); 
             
}

componentWillUnmount() { //Cerrar Subcripciones

}

render() {
const { classes } = this.props;

  if (this.state.isLoggin === true)
  {
  return (
    
    <React.Fragment>
      <Paper className="Paper-main" square>
          {
            (() => {
              
            if (tokenInfo.plataforma === 2) //Si es Usuario Admin
             {
              
              return (
                <React.Fragment>
                 <Paper variant="outlined" className={classes.paperTitle}>
                  <Typography component='span' variant="h6" className="disableTouchOptions">
                   <strong>Cursos registrados para Examen Extraordinario</strong>
                  </Typography>
                 </Paper>
                 <div ref={this.tablaRef} style={{ marginLeft: !movil ? globales.tabla.marginleft : globales.tabla.marginleft_movil, marginRight: !movil ? globales.tabla.marginright : globales.tabla.marginright_movil }} className="disableTouchOptions">
                 <CustomTable 
                  Columns={columns} 
                  Rows={this.state.rows}
                  Grouping={[{ columnName: 'DESCRIPCION_NIVEL' }]}                      
                  TableColumnExtensions={columnExtensions} 
                  columnWidths={columnExtensions}
                  DefaultHiddenColumnNames={['ID_SECCION_CLIENTE']}
                  ExpandedGroups={this.state.expandedGroups}
                  ChangeExpandedGroups={this.changeExpandedGroups}
                  getRowId={row => row.ID_SECCION_CLIENTE}
                  VirtualTable_cellComponent={VirtualTable_cellComponent}
                  height={this.state.heightTableMain} 
                  loading={this.state.loadingMain}
                  enabledFilterRows                    
                  showSelectionColumn 
                  groupContentComponent={GroupCellContent}
                  tableSelectionCellComponent={TableSelectionCellComponent(this.state.loadingCheck, checkId)}
                  Selection={this.state.selection}
                  ChangeSelection={this.changeSelection}
                  leftColumnsFixed={[TableSelection.COLUMN_TYPE]}
                  columnFixedCellComponent={ColumnFixed_cellComponent} 
                  FilteringColumnExtensions={settingFilter}          
                />                  
                </div>
               
               <Backdrop open={this.state.loadingMain || this.state.loadingCheck}
                         className={classes.backdrop} 
                         invisible 
                         transitionDuration={0}/>

                </React.Fragment>
              );

             }             
             
            })()

          }

        </Paper>
      </React.Fragment>
  );
  }
else if (this.state.isLoggin === false)
{
  //Auth.logout();
  window.location.reload();
  return; //((<Redirect to="/login"/>))
}
return null;

}//FIN RENDER
}

)
